"use client"

import AdvisorTemplateClient from '@/components/advisor/AdvisorTemplateClient'
import type { Page } from '@/lib/pagesStore'

export default function ClientPage({ data }: { data: Page }) {
  return (
    <AdvisorTemplateClient
      product={{ ...data, advisorName: data.title, avatar: data.avatar || data.heroImages?.[0] }}
    />
  )
}
